import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryServer from 'graphql/queries/QueryServer'

const FetchServer = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'server', QueryServer, {
			//instant: true,
			resultPath: [ 'server' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}

export default FetchServer
